module.exports = __webpack_public_path__ + "img/health-guide-healthy-habits.46f97407.png";